import { InjectionToken } from '@angular/core';

// Domain-specific injection tokens for API base paths
export const AUDIT_API_BASE_PATH = new InjectionToken<string>('auditApiBasePath');
export const USERS_API_BASE_PATH = new InjectionToken<string>('usersApiBasePath');
export const COMPANIES_API_BASE_PATH = new InjectionToken<string>('companiesApiBasePath');
export const SALES_API_BASE_PATH = new InjectionToken<string>('salesApiBasePath');
export const LOCATIONS_API_BASE_PATH = new InjectionToken<string>('locationsApiBasePath');
export const BRANDS_API_BASE_PATH = new InjectionToken<string>('brandsApiBasePath');
export const VENDORS_API_BASE_PATH = new InjectionToken<string>('vendorsApiBasePath');
export const CURRENCIES_API_BASE_PATH = new InjectionToken<string>('currenciesApiBasePath');
export const CUSTOMERS_API_BASE_PATH = new InjectionToken<string>('customersApiBasePath');
export const DOCUMENTS_API_BASE_PATH = new InjectionToken<string>('documentsApiBasePath');
export const FINANCE_API_BASE_PATH = new InjectionToken<string>('financeApiBasePath');
export const INFRASTRUCTURE_API_BASE_PATH = new InjectionToken<string>('infrastructureApiBasePath');
export const INVENTORY_API_BASE_PATH = new InjectionToken<string>('inventoryApiBasePath');
export const PRODUCT_CATALOGUE_API_BASE_PATH = new InjectionToken<string>('productCatalogueApiBasePath');
export const SCHEDULER_API_BASE_PATH = new InjectionToken<string>('schedulerApiBasePath');
export const SETTINGS_API_BASE_PATH = new InjectionToken<string>('settingsApiBasePath');
export const SUBSCRIPTIONS_API_BASE_PATH = new InjectionToken<string>('subscriptionsApiBasePath');
export const TASKS_API_BASE_PATH = new InjectionToken<string>('tasksApiBasePath');
export const TAX_API_BASE_PATH = new InjectionToken<string>('taxApiBasePath');
export const CONTACTS_API_BASE_PATH = new InjectionToken<string>('contactsApiBasePath');
export const REPORTING_API_BASE_PATH = new InjectionToken<string>('reportingApiBasePath');

// API Domain mapping type
export interface ApiDomainMapping {
  audit: string;
  users: string;
  companies: string;
  sales: string;
  locations: string;
  brands: string;
  vendors: string;
  currencies: string;
  customers: string;
  documents: string;
  finance: string;
  infrastructure: string;
  inventory: string;
  productCatalogue: string;
  reporting: string;
  scheduler: string;
  settings: string;
  subscriptions: string;
  tasks: string;
  tax: string;
  contacts: string;
}
